import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CarouselSiteImage from './CarouselSiteImage';
import CarouselControlButton from '../CarouselControlButton';

const SiteImagesCarousel = ({
  images,
  primaryImgId = null,
  heightStyle = '',
  isModal = false,
  modalImageId = null,
  onCurrentImageChange = null,
  setModalImageId = () => {},
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Set initial currentIndex based on primaryImgId
  useEffect(() => {
    if (primaryImgId !== null && primaryImgId !== undefined) {
      const index = images.findIndex((img) => img.id === (modalImageId !== null ? modalImageId : primaryImgId));
      if (index !== -1) {
        setCurrentIndex(index);
      } else if (images?.length > 0) {
        setCurrentIndex(0);
      }
    } else if (images?.length > 0) {
      setCurrentIndex(0);
    }
  }, [primaryImgId, images, modalImageId]);

  useEffect(() => {
    if (!onCurrentImageChange) return;
    onCurrentImageChange(images[currentIndex]?.id || null);
  }, [currentIndex, images, onCurrentImageChange]);

  const goToPrevious = (e) => {
    e.stopPropagation();
    const nextIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(nextIndex);
    if (modalImageId !== null) setModalImageId(images[nextIndex]?.id || null);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    const nextIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(nextIndex);
    if (modalImageId !== null) setModalImageId(images[nextIndex]?.id || null);
  };

  return (
    <div className="relative w-full overflow-hidden mx-auto">
      <div className="relative w-full h-full">
        {images?.length
          ? images.map((siteImage, index) => (
            <CarouselSiteImage
              key={siteImage.id}
              image={siteImage?.image?.url || null}
              imageID={siteImage.id}
              isActive={index === currentIndex}
              heightStyle={heightStyle}
              isModal={isModal}
            />
          ))
          : (
            <CarouselSiteImage
              isActive
              heightStyle={heightStyle}
            />
          )}
      </div>

      {images?.length > 1 && (
        <>
          <CarouselControlButton
            title="Previous"
            type="prev"
            onClick={goToPrevious}
          />
          <CarouselControlButton
            title="Next"
            type="next"
            onClick={goToNext}
          />
        </>
      )}
    </div>
  );
};

SiteImagesCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  ).isRequired,
  primaryImgId: PropTypes.number,
  heightStyle: PropTypes.string,
  isModal: PropTypes.bool,
  modalImageId: PropTypes.number,
  onCurrentImageChange: PropTypes.func,
  setModalImageId: PropTypes.func,
};

export default SiteImagesCarousel;
